import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../assets/css/recu.css";

class RecuDetail extends Component {
    state = { colis: [], loading: true, error: "" }

    componentDidMount() {
        this.getColis()
    }

    async getColis() {
        const colisId = this.props.match?.params?.id
        if (!colisId) {
            this.setState({ loading: false, error: "Lien de suivi invalide." })
            return
        }

        try {
            const apiUrl = process.env.REACT_APP_API_EVIVEMANIFESTE || ""
            const response = await fetch(apiUrl + "/recus/$colis.id$/" + encodeURIComponent(colisId))
            const data = await response.json()
            if (!response.ok) throw new Error(data?.msg || "Impossible de charger les informations de votre colis.")
            this.setState({ colis: Array.isArray(data) ? data : data ? [data] : [], loading: false })
        } catch (error) {
            this.setState({ loading: false, error: error.message || "Impossible de charger les informations de votre colis." })
        }
    }

    formatAmount = (value) => Number(value || 0).toLocaleString("fr-FR", {
        minimumFractionDigits: 0, maximumFractionDigits: 2
    }) + " $"

    formatDate = (value) => value
        ? new Date(value).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })
        : "Non renseigné"

    formatAddress = (branch) => {
        if (!branch) return "Non renseignée"
        return [branch.avenue, branch.neighborhood, branch.municipality, branch.region, branch.city, branch.country]
            .filter(Boolean).join(", ") || branch.other_adress || "Non renseignée"
    }

    statusInfo = (status) => {
        if (status === "Manifeste") return { className: "is-transit", label: "En transit || A destination" }
        if (status === "EnStock") return { className: "is-stock", label: "En stock" }
        return { className: "is-delivered", label: status || "Traité" }
    }

    renderBranch = (title, branch, step) => (
        <div className="recu-route__stop">
            <span className="recu-route__marker">{step}</span>
            <div>
                <span className="recu-label">{title}</span>
                <h3>{branch?.city || "Ville non renseignée"}</h3>
                <p>{this.formatAddress(branch)}</p>
                {(branch?.tel || branch?.tel1 || branch?.tel2) && (
                    <a href={"tel:" + (branch.tel || branch.tel1 || branch.tel2)}>
                        {[branch.tel, branch.tel1, branch.tel2].filter(Boolean).join(" / ")}
                    </a>
                )}
            </div>
        </div>
    )

    renderInfoRow = (label, value, emphasis = false) => (
        <div className="recu-info-row">
            <span>{label}</span>
            <strong className={emphasis ? "text-danger" : ""}>{value}</strong>
        </div>
    )

    renderColi = (coli) => {
        const invoices = coli.invoices || (coli.invoice ? [coli.invoice] : [])
        const details = coli.colidetails || []
        const manifestes = coli.manifestecolis || []
        const totalPaid = invoices.reduce((total, invoice) => total + Number(invoice.price || 0), 0)
        const totalDue = invoices.reduce((total, invoice) => total + Number(invoice.due || 0), 0)
        const status = this.statusInfo(coli.status)
        const clientAddress = [coli.client?.adress, coli.client?.region, coli.client?.city, coli.client?.country]
            .filter(Boolean).join(", ") || "Non renseignée"

        return (
            <article className="recu-detail" key={coli.id}>
                <section className="recu-hero">
                    <div className="recu-hero__top">
                        <div><span className="recu-label">Référence du colis</span><h2>{coli.ref_coli || "Sans référence"}</h2></div>
                        <span className={"recu-status " + status.className}><span />{status.label}</span>
                    </div>
                    <div className="recu-metrics">
                        <div><span>Colis</span><strong>{coli.coli_count || 0}</strong></div>
                        <div><span>Articles</span><strong>{coli.quantity || 0}</strong></div>
                        <div><span>Montant</span><strong>{this.formatAmount(coli.price)}</strong></div>
                        <div><span>Déposé le</span><strong>{this.formatDate(coli.createdAt)}</strong></div>
                    </div>
                </section>

                <section className="recu-panel">
                    {this.renderHeading("01", "Parcours", "Itinéraire du colis")}
                    <div className="recu-route">
                        {this.renderBranch("Agence d'origine", coli.origine, "A")}
                        {this.renderBranch("Agence de destination", coli.destination, "B")}
                    </div>
                </section>

                <div className="recu-grid">
                    <section className="recu-panel">
                        {this.renderHeading("02", "Destinataire", "Informations client")}
                        <div className="recu-info-list">
                            {this.renderInfoRow("Nom", coli.client?.name || "Non renseigné")}
                            {this.renderInfoRow("Téléphone", coli.client?.tel || "Non renseigné")}
                            {this.renderInfoRow("Email", coli.client?.email || "Non renseigné")}
                            {this.renderInfoRow("Adresse", clientAddress)}
                        </div>
                    </section>
                    <section className="recu-panel">
                        {this.renderHeading("03", "Facturation", "Paiements")}
                        <div className="recu-payment-total">
                            <span>Reste à payer</span>
                            <strong className={totalDue > 0 ? "text-danger" : ""}>{this.formatAmount(totalDue)}</strong>
                        </div>
                        <div className="recu-info-list">
                            {this.renderInfoRow("Montant payé", this.formatAmount(totalPaid))}
                            {invoices.map((invoice, index) => this.renderInfoRow(
                                invoice.ref_invoice || "Facture " + (index + 1), this.formatAmount(invoice.price)
                            ))}
                        </div>
                    </section>
                </div>

                <section className="recu-panel">
                    {this.renderHeading("04", "Inventaire", "Contenu du colis")}
                    {details.length > 0 ? (
                        <div className="recu-items">
                            {details.map((detail, index) => (
                                <div className="recu-item" key={detail.id || index}>
                                    <div className="recu-item__title">
                                        <span>{String(index + 1).padStart(2, "0")}</span>
                                        <div><strong>{detail.article?.name || "Article non renseigné"}</strong><small>{this.formatAmount(detail.price)}</small></div>
                                    </div>
                                    <div className="recu-item__stats">
                                        <span>Quantité<strong>{detail.quantity || 0} {detail.unite?.name || ""}</strong></span>
                                        <span>En stock<strong>{detail.stock || 0} {detail.unite?.name || ""}</strong></span>
                                        <span>Expédié<strong>{detail.expedie || 0} {detail.unite?.name || ""}</strong></span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : <p className="recu-empty">Aucun détail renseigné.</p>}
                </section>

                <section className="recu-panel">
                    {this.renderHeading("05", "Suivi", "Expédition")}
                    <div className="recu-info-list">
                        {this.renderInfoRow("En stock", coli.stock || 0)}
                        {this.renderInfoRow("Expédié", coli.expedie || 0)}
                        {manifestes.length > 0 ? manifestes.map((item, index) => this.renderInfoRow(
                            "Manifeste " + (index + 1),
                            [item.manifeste?.ref_manifeste, item.manifeste?.status].filter(Boolean).join(" - ") || "Non renseigné"
                        )) : this.renderInfoRow("Manifeste", "Aucun manifeste associé")}
                    </div>
                </section>
            </article>
        )
    }

    renderHeading = (number, eyebrow, title) => (
        <div className="recu-panel__heading">
            <div className="recu-section-icon">{number}</div>
            <div><span>{eyebrow}</span><h2>{title}</h2></div>
        </div>
    )

    render() {
        const colis = this.state.colis.map(this.renderColi)
        return (
            <main className="dashboard__content bg-light-2 recu-page">
                <div className="container">
                    <header className="recu-page__header">
                        <Link to="/recus" className="recu-back" aria-label="Retour à mes reçus">←</Link>
                        <div><span className="recu-page__eyebrow">Suivi de livraison</span><h1>Détails de mon colis</h1><p>Toutes les informations de votre expédition, au même endroit.</p></div>
                    </header>
                    {this.state.loading && <div className="recu-state"><span className="recu-loader" />Chargement des informations...</div>}
                    {!this.state.loading && this.state.error && <div className="recu-state is-error">{this.state.error}</div>}
                    {!this.state.loading && !this.state.error && colis.length === 0 && <div className="recu-state">Aucun colis trouvé pour ce lien.</div>}
                    {!this.state.loading && !this.state.error && colis}
                </div>
            </main>
        )
    }
}

export default RecuDetail
